import React from 'react';

const ViewPortShutters = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 86.677 86.676"
			className={className}
		>
			<g fill="currentColor">
				<path d="M18.516 64.846a1.835 1.835 0 1 0 1.3.537 1.833 1.833 0 0 0-1.3-.537Z" />
				<path d="M68.161 64.846a1.835 1.835 0 1 0 1.3.537 1.833 1.833 0 0 0-1.3-.537Z" />
				<path d="M18.516 21.83a1.835 1.835 0 1 0-1.3-.537 1.833 1.833 0 0 0 1.3.537Z" />
				<path d="M68.161 21.83a1.835 1.835 0 1 0-1.3-.537 1.833 1.833 0 0 0 1.3.537Z" />
				<path d="M62.308 44.108h4.819v-1.541h-4.819v-2.918l-6.387 3.688 6.387 3.688Z" />
				<path d="m24.495 47.026 6.385-3.688-6.385-3.688v2.918h-4.819v1.541h4.819Z" />
				<path d="M30.618 17.065Z" />
				<path d="M30.618 69.611Z" />
				<path d="M30.619 69.61a29.189 29.189 0 0 0 27.194-51.62 29.187 29.187 0 1 0-27.194 51.616Zm25.279-48.274a25.323 25.323 0 0 1 12.77 22.005 25.191 25.191 0 0 1-3.523 12.893 25.47 25.47 0 0 1-9.247 9.108c-.362.208-.732.4-1.1.593v-45.19c.374.189.742.385 1.1.593ZM21.98 29.714a25.449 25.449 0 0 1 10.32-9.181c.4-.195.809-.378 1.221-.553v46.718a22.69 22.69 0 0 1-1.221-.553 25.345 25.345 0 0 1-10.32-36.433Z" />
				<path d="M57.812 68.683Z" />
				<path d="M7.402 19.104a43.278 43.278 0 1 0 19.066-15.7 43.142 43.142 0 0 0-19.066 15.7Zm13.86-8.511A39.422 39.422 0 1 1 6.953 27.968a39.293 39.293 0 0 1 14.309-17.375Z" />
			</g>
		</svg>
	);
};

export default ViewPortShutters;
